<template>
    <div class="footer">
        <div class="footer-box">

            <!-- <div class="menu-box">
                <p @click="selectMenu(1)">首頁</p>
                <p @click="selectMenu(2)">關於我們</p>
                <p @click="selectMenu(4)">招聘信息</p>
                <p @click="selectMenu(5)">合作品牌</p>
            </div> -->
            <div class="connect">
                <p>電話：00852-39622878</p>
                <p>郵箱：sandy@wavetecmobi.com</p>
                <p>地址：FLAT/ROOM 1101D，11/F，LIPPO SUN PLAZA，28 CANTON ROAD,TSIM SHA TSUI,KOWLOON，HONGKONG</p>
            </div>
            <div class="customer">
                <div @click="selectMenu(2)">關於我們</div>
                <div @click="selectMenu(4)">招聘信息</div>
            </div>
            <img src="../assets/logo-1.png" class="logo-1">
        </div>
        <div class="copyright">
            © WAVETECMOBI LIMITED
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "aboutUs" }); break;
                case 3: this.$router.push({ path: "legalPerson" }); break;
                case 4: this.$router.push({ path: "offers" }); break;
                case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
            window.scrollTo(0, 0)
        }
    }
}
</script>
<style lang="less" scoped>
.footer {
    .footer-box {
        height: 260px;
        background: #404040;
        padding: 120px 252px 40px 252px;
        display: flex;
        justify-content: space-between;

        .logo-1 {
            width: 152px;
            height: 65px;
        }

        .menu-box {
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            height: 300px;


        }

        .connect {
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            width: 400px;
            height: 200px;
            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: space-between;
        }

        .customer {
            width: 120px;
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            height: 100px;

            div {
                cursor: pointer;
            }
        }
    }

    .copyright {
        height: 64px;
        background: #2D2D2D;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 64px;
        text-align: center;
    }
}
</style>